import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider
} from "@mui/material";

const PropertyRequestModal = ({ open, onClose, data }) => {
  if (!data) return null;

  const Row = ({ label, value }) => (
    <Typography sx={{ mb: 1 }}>
      <strong>{label}:</strong> {value || "-"}
    </Typography>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>
        Property Request Details
      </DialogTitle>

      <DialogContent dividers>
        <Box>

          {/* 👤 USER DETAILS */}
          <Typography variant="h6" sx={{ mb: 1 }}>
            User Details
          </Typography>
          <Row label="User Name" value={data.username} />
          <Row label="Mobile Number" value={data.mobile_no} />
          

          <Divider sx={{ my: 2 }} />

          {/* BASIC */}
          <Typography variant="h6" sx={{ mb: 1 }}>
            Property Info
          </Typography>

          <Row label="Looking For" value={data.looking_for} />
          <Row label="Property Type" value={data.property_type} />

          {/* LOCATION */}
          <Row label="Location" value={data.location} />
          <Row label="Latitude" value={data.lat} />
          <Row label="Longitude" value={data.long} />

          {/* SIZE */}
          <Row
            label="Size"
            value={`${data.length || "-"} x ${data.width || "-"} ${data.units || ""}`}
          />

          {/* BUDGET */}
          <Row
            label="Budget Range"
            value={`₹${data.min_budget?.toLocaleString() || "-"} - ₹${data.max_budget?.toLocaleString() || "-"}`}
          />

          {/* EXTRA DETAILS */}
          <Row label="Bedrooms" value={data.no_of_bedrooms} />
          <Row label="Min Monthly Rent" value={data.min_monthly_rent} />
          <Row label="Max Monthly Rent" value={data.max_monthly_rent} />
          <Row label="Min Year Lease" value={data.min_year_lease} />
          <Row label="Max Year Lease" value={data.max_year_lease} />
          <Row label="Min Acres" value={data.min_acres} />
          <Row label="Max Acres" value={data.max_acres} />
          <Row label="Floor" value={data.floor} />
          {/* <Row label="Comment" value={data.comment} /> */}

          <Row
            label="Created At"
            value={new Date(data.created_at).toLocaleString()}
          />
          <Row
            label="Updated At"
            value={new Date(data.updated_at).toLocaleString()}
          />

        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PropertyRequestModal;
